import { lessonCountText, slideCountText } from "../../lib/plurals.ts";

/**
 * Сводка заготовки одной строкой: «12 слайдов · 3 урока».
 *
 * Текст слота, который существует ТОЛЬКО ниже порога колонок (`data-wide="none"`
 * в `PlanRow.tsx`). На широкой раскладке те же две величины стоят своими
 * колонками под своими заголовками, а ниже порога колонок нет, значит нет и
 * заголовков: величина обязана назвать себя сама.
 *
 * ⚠️ Отдельным модулем с тестами, потому что правил тут три, и каждое про ТЕКСТ,
 * который читает преподаватель:
 *
 * 1. **при нуле слайдов «0 слайдов» не пишется.** Машинный счёт вслух не
 *    говорят, а факт «заготовка пустая» это как раз то, ради чего в список и
 *    смотрят;
 * 2. **ноль уроков молчит.** «0 уроков» стояло бы у каждой новой заготовки, то
 *    есть у половины списка, и не отвечало бы ни на один вопрос;
 * 3. **`null` уроков молчит тоже, и молчит по ДРУГОЙ причине.** `null` значит
 *    «сервер в этом ответе уроки не считал» (разбор у самого слота в
 *    `PlanRow.tsx`), и притворяться нулём он не должен.
 *
 * Формы слов берутся общим словарём числительных (`lib/plurals.ts`), а не
 * пишутся здесь: «12 слайдов» на одном экране и «12 слайда» на соседнем
 * замечает ровно тот человек, которому мы это показываем.
 */
export function planBriefText(slideCount: number, lessonCount: number | null): string {
  const slides = slideCount === 0 ? "слайдов пока нет" : slideCountText(slideCount);
  if (lessonCount === null || lessonCount === 0) return slides;
  // Разделитель тот же, что у подписей по всему продукту: величины
  // равноправные, и запятая сделала бы вторую продолжением первой
  return `${slides} · ${lessonCountText(lessonCount)}`;
}
